const accordionHeader = document.querySelectorAll( '.amdg-accordion__header' );
accordionHeader.forEach( ( header ) => {
	header.addEventListener( 'click', function () {
		const accordionContent = header.parentElement.querySelector(
			'.amdg-accordion__content'
		);
		const accordionMaxHeight = accordionContent.style.maxHeight;

		// Condition handling
		if ( accordionMaxHeight === '0px' || accordionMaxHeight.length === 0 ) {
			accordionContent.style.maxHeight = `${
				accordionContent.scrollHeight + 32
			}px`;
			header
				.querySelector( '.amdg-accordion__toggle-open' )
				.classList.remove( 'active' );
			header
				.querySelector( '.amdg-accordion__toggle-close' )
				.classList.add( 'active' );
		} else {
			accordionContent.style.maxHeight = `0px`;
			header
				.querySelector( '.amdg-accordion__toggle-open' )
				.classList.add( 'active' );
			header
				.querySelector( '.amdg-accordion__toggle-close' )
				.classList.remove( 'active' );
		}
	} );
} );
